var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotifyLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3093 5.00621C11.4604 2.72042 5.11156 2.51024 1.4372 3.6254C0.847166 3.80435 0.223213 3.47126 0.0444137 2.88124C-0.134385 2.29094 0.198393 1.66742 0.788844 1.48804C5.00659 0.207757 12.0183 0.455021 16.4493 3.08527C16.9802 3.40039 17.1543 4.0858 16.8396 4.61565C16.5248 5.14637 15.8388 5.3213 15.3093 5.00621H15.3093ZM15.1832 8.39175C14.9133 8.82991 14.3404 8.96724 13.9028 8.69828C10.6939 6.72575 5.80086 6.15439 2.00431 7.30678C1.51196 7.4555 0.991981 7.17787 0.84255 6.68655C0.694099 6.1942 0.971877 5.6752 1.4632 5.5255C5.80009 4.2096 11.1912 4.84695 14.8769 7.11193C15.3145 7.38142 15.4522 7.95461 15.1831 8.3918L15.1832 8.39175ZM13.7221 11.6431C13.5893 11.8586 13.3546 12 13.0869 12C12.9434 12 12.8094 11.9594 12.6958 11.8889L12.699 11.8908C9.89488 10.1771 6.36571 9.78996 2.20906 10.7394C1.80853 10.8312 1.40944 10.5802 1.31804 10.1798C1.22621 9.77922 1.47632 9.38014 1.87771 9.28873C6.42635 8.24884 10.328 8.69642 13.4753 10.6196C13.8262 10.834 13.9367 11.2923 13.7221 11.6431L13.7221 11.6431Z",
    fill: "#1ED760"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotifyLines);
export default __webpack_public_path__ + "static/media/spotify-lines.cd5befdab31f41ce863d7b70ed2ce7f6.svg";
export { ForwardRef as ReactComponent };